var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );
dependencies["modal/modal-contents.j2"] = require( "modal/modal-contents.j2" );
dependencies["partials/order-status-modal-body.j2"] = require( "partials/order-status-modal-body.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/order-status.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/form-validation.j2", false, "core/templates/modal/order-status.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayGeneralErrors")) {
var t_4 = t_1.displayGeneralErrors;
} else {
cb(new Error("cannot import 'displayGeneralErrors'")); return;
}
context.setVariable("displayGeneralErrors", t_4);
if(t_1.hasOwnProperty("displayFieldErrors")) {
var t_5 = t_1.displayFieldErrors;
} else {
cb(new Error("cannot import 'displayFieldErrors'")); return;
}
context.setVariable("displayFieldErrors", t_5);
if(t_1.hasOwnProperty("hasErrors")) {
var t_6 = t_1.hasErrors;
} else {
cb(new Error("cannot import 'hasErrors'")); return;
}
context.setVariable("hasErrors", t_6);
if(t_1.hasOwnProperty("validatedField")) {
var t_7 = t_1.validatedField;
} else {
cb(new Error("cannot import 'validatedField'")); return;
}
context.setVariable("validatedField", t_7);
output += "\n\n";
env.getTemplate("modal/modal-contents.j2", true, "core/templates/modal/order-status.j2", false, function(t_9,_parentTemplate) {
if(t_9) { cb(t_9); return; }
parentTemplate = _parentTemplate
for(var t_8 in parentTemplate.blocks) {
context.addBlock(t_8, parentTemplate.blocks[t_8]);
}
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("modal_styles"))(env, context, frame, runtime, function(t_11,t_10) {
if(t_11) { cb(t_11); return; }
output += t_10;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("modal_contents"))(env, context, frame, runtime, function(t_13,t_12) {
if(t_13) { cb(t_13); return; }
output += t_12;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_modal_styles(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\n    o-modal--small c-order-status__modal\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_modal_contents(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\n\n<form novalidate class=\"c-order-status__form\" id=\"order-status\" method=\"post\" action=\"\" enctype=\"application/x-www-form-urlencoded\">\n\n    <div class=\"o-row\">\n\n        <div class=\"o-column o-extra-small--12 c-modal-login\">\n\n            ";
env.getTemplate("partials/order-status-modal-body.j2", false, "core/templates/modal/order-status.j2", null, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
t_14.render(context.getVariables(), frame, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
output += t_15
output += "\n\n        </div>\n\n    </div>\n\n</form>\n\n";
cb(null, output);
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_modal_styles: b_modal_styles,
b_modal_contents: b_modal_contents,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/order-status.j2"] , dependencies)